import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Dashboard from '../pages/Dashboard';
import PacoteManagerPage from '../pages/PacoteManagerPage';
import PacksManagerPage from '../pages/PacksManagerPage';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import ProtectedRoute from '../components/ProtectedRoute';


export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/pacotes" element={<ProtectedRoute><PacoteManagerPage /></ProtectedRoute>} />
      <Route path="/admin/packs" element={<ProtectedRoute><PacksManagerPage /></ProtectedRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
